import { createFileRoute } from '@tanstack/react-router';

import { CatalogWrapper } from '../../wrapper/CatalogWrapper';

export const Route = createFileRoute('/_auth/catalog')({
  component: CatalogWrapper,
});
